module.exports = __webpack_public_path__ + "img/product_47.bbe2ddb.webp";